import axios from 'axios';

export const MyReportsApi = {
  getMyChildrenListFromIntegration: () => axios.get(`api/public/info/self/children`),
  loadDataReport: filter =>
    axios.get(`/api/public/info/visit_log_ddo_child?filter=${filter}`),
  getSignStringForAttendance: params =>
    axios.post(`/api/info/signature/sign_string/attendance_sheet_consent`, params),
  confirmOrRejectAttendance: params =>axios.post(`/api/public/attendance_sheet_consent/confirm`, params),
  loadHistoryDataReport: filter =>
    axios.get(`/api/public/info/self/attendance_sheet_consent?filter=${filter}`),
  loadChildDdoReport: filter =>
    axios.get(`/api/public/info/paging/contingent/child?filter=${filter}`)
};
